/**
 * One reply bubble per run.
 *
 * The platform publishes an `agent_message` for every completed step that
 * carries a user-facing summary, and a multi-step workflow produces several:
 * the Client Backends copilot's router and code writer are JSON agents, which
 * the runtime asks for a summary fence, so their internal notes ("I classified
 * this as…", "Created the endpoint…") arrived as bubbles before the actual
 * reply. A later message of the same run replaces the earlier one in place,
 * so the rail shows the step the user is meant to read — the last — while the
 * tool activity rows still show the progress. Position (and therefore the
 * thumbs' message index) is kept.
 */
export function mergeAssistantReply(messages, reply) {
  if (!reply.runId) {
    return [...messages, reply];
  }
  let index = -1;
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const message = messages[i];
    if (message.role === 'assistant' && message.runId === reply.runId) {
      index = i;
      break;
    }
    if (message.role === 'user') {
      break;
    }
  }
  if (index === -1) {
    return [...messages, reply];
  }
  const next = messages.slice();
  next[index] = { ...messages[index], ...reply };
  return next;
}
